import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { WindowShopManagerNutritionTableComponent } from './window-shop-manager-nutrition-table.component';


@NgModule({
  imports: [
    CommonModule,
    MatDividerModule
  ],
  exports: [
    WindowShopManagerNutritionTableComponent
  ],
  providers: [
  ],
  declarations: [
    WindowShopManagerNutritionTableComponent
  ]
})
export class WindowShopManagerNutritionTableModule { }